<template lang="html">
  <b-container>
    <b-row>
      <b-col md="4">
        <label>LastFM Api Key</label>
        <b-form-input v-model="apiKey" placeholder="apiKey" />
        <p class="mt-3">
          <b-btn
            size="sm"
            variant="outline-secondary"
            class="mr-1"
            @click="saveKeyToLocal"
          >
            Save to local storage
          </b-btn>
          <b-btn
            size="sm"
            variant="outline-secondary"
            class="mr-1"
            @click="clearKey"
          >
            Clear key
          </b-btn>
        </p>
        <p><b-btn @click="loadDjangoData">Load data from Django</b-btn></p>

        <div v-if="data">
          <h2>Django data</h2>

          <p>
            <b-link
              :href="`https://youtube.com/watch?v=${data.youtube_id}`"
              target="_blank"
            >
              View on Youtube
            </b-link>
          </p>

          <p>
            <b-link
              :href="
                `https://api-py38.ukeability.org/admin/ukeability/song/${
                  data.id
                }/change/`
              "
              target="_blank"
            >
              View in Django
            </b-link>
          </p>

          <code>
            <pre class="small" v-text="returnPrettyJson(data)" />
          </code>
        </div>
      </b-col>

      <b-col v-if="data" md="4">
        <p>
          <label>Title</label>
          <b-form-input
            v-model="title"
            placeholder="Title"
            @keyup.enter.native="searchForTrack"
          />
        </p>
        <b-btn @click="searchForTrack">Search Last.fm</b-btn>

        <div v-if="trackData" class="mt-3 alert-info alert">
          <h4>Results</h4>

          <div
            v-for="(track, idx) in trackData.results.trackmatches.track"
            :key="'track' + idx"
          >
            <p>{{ track.artist }}</p>
            <p>{{ track.name }}</p>
            <p class="small">
              <b-link :href="track.url" target="_blank">LastFM page</b-link>
            </p>
            <b-btn
              size="sm"
              variant="outline-primary"
              @click="loadTrackInfo(track.artist, track.name)"
            >
              Load this one
            </b-btn>
            <hr />
          </div>
          <ObjectPrint :data="trackData" title="trackData" />
        </div>
      </b-col>

      <b-col v-if="trackInfoData" md="4">
        <p>
          <label>Official Title</label>
          <b-form-input
            v-model="trackRealTitle"
            placeholder="Official track title"
          />
        </p>

        <p>
          <label>Track MBID</label>
          <b-form-input
            v-model="trackRealTrackMbid"
            placeholder="Official track mbid"
          />
        </p>

        <p>
          <label>Primary Artist</label>
          <b-form-input
            v-model="trackRealPrimaryArtistName"
            placeholder="Primary artist name"
          />
        </p>

        <p>
          <label>Primary Artist Mbid</label>
          <b-form-input
            v-model="trackRealPrimaryArtistMbid"
            placeholder="Primary artist mbid"
          />
        </p>

        <p>
          <label>Related Artists (including primary artist)</label>
          <vue-tags-input
            v-model="trackRealArtist"
            :tags="trackRealArtists"
            placeholder="Add artist"
            @tags-changed="(newArtist) => (trackRealArtists = newArtist)"
          />
        </p>

        <p>
          <label>Tags</label>
          <vue-tags-input
            v-model="trackRealTag"
            :tags="trackRealTags"
            placeholder="Add tag"
            @tags-changed="(newTag) => (trackRealTags = newTag)"
          />
        </p>

        <p>
          <b-btn size="lg" variant="success" @click="saveToDatabase">
            Save to Database
          </b-btn>
        </p>

        <p>
          <b-btn
            size="sm"
            variant="success"
            @click="
              loadTrackInfoFromAudioDb(
                trackRealPrimaryArtistName,
                trackRealTitle
              )
            "
          >
            Try AudioDb
          </b-btn>
        </p>

        <ObjectPrint
          :data="trackInfoDataAudioDb"
          title="Audio Db"
          class="mt-5"
        />

        <ObjectPrint :data="trackInfoData" title="Last FM" class="mt-5" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import Storage from "store2";
import VueTagsInput from "@johmun/vue-tags-input";
import map from "lodash/map";
import random from "lodash/random";
export default {
  name: "Review",
  components: {
    VueTagsInput,
  },
  data() {
    return {
      data: null,
      title: "",
      apiKey: "",
      trackData: null,
      trackInfoData: null,
      trackInfoDataAudioDb: null,
      trackRealTitle: "",
      trackRealPrimaryArtistName: "",
      trackRealPrimaryArtistMbid: "",
      trackRealArtist: "",
      trackRealArtists: [],
      trackRealTags: [],
      trackRealTag: "",
      trackRealTrackMbid: "",
      trackMbid: "",
      //apiRoot: "http://127.0.0.1:8000"
      apiRoot: "https://api-py38.ukeability.org",
    };
  },
  computed: {},
  mounted() {
    this.apiKey = Storage.get("apiKey", "");
  },
  methods: {
    loadDjangoData() {
      var _v = this;
      var randomInt = random(0, 99999999999);
      var url = `${
        this.apiRoot
      }/v1/songs/?original_metadata_added=false&ordering=-youtube_view_count&page_size=1&random=${randomInt}`;

      _v.data = null;
      _v.trackData = null;
      _v.trackInfoData = null;

      axios.get(url).then((response) => {
        console.log(response.data);
        _v.data = response.data.results[0];
        _v.title = _v.data.title;
      });
    },
    returnPrettyJson(_data) {
      return JSON.stringify(_data, undefined, 2);
    },
    saveKeyToLocal() {
      Storage.set("apiKey", this.apiKey);
    },
    clearKey() {
      Storage.remove("apiKey");
      this.apiKey = "";
    },
    searchForTrack() {
      var _v = this;
      var url = `https://ws.audioscrobbler.com/2.0/?method=track.search&track=${encodeURIComponent(
        this.title
      )}&api_key=${this.apiKey}&format=json&limit=10`;
      axios.get(url).then((response) => {
        console.log(response.data);
        _v.trackData = response.data;
      });
    },
    loadTrackInfo(artist, trackName) {
      var _v = this;
      var url = `https://ws.audioscrobbler.com/2.0/?method=track.getInfo&api_key=${
        this.apiKey
      }&artist=${encodeURIComponent(artist)}&track=${encodeURIComponent(
        trackName
      )}&format=json`;
      axios.get(url).then((response) => {
        console.log(response.data);
        _v.trackInfoData = response.data;
        _v.trackRealTitle = _v.trackInfoData.track.name;
        _v.trackRealTrackMbid = _v.trackInfoData.track.mbid;
        _v.trackRealArtists = [{ text: _v.trackInfoData.track.artist.name }];
        _v.trackRealTags = map(_v.trackInfoData.track.toptags.tag, (t) => {
          return { text: t.name };
        });
        _v.trackRealPrimaryArtistMbid = _v.trackInfoData.track.artist.mbid;
        _v.trackRealPrimaryArtistName = _v.trackInfoData.track.artist.name;
        _v.trackRealTitle = _v.trackInfoData.track.name;
      });
    },
    loadTrackInfoFromAudioDb(artist, trackName) {
      var _v = this;
      // https://www.theaudiodb.com/api/v1/json/1/searchtrack.php?s=John%20Legend&t=All%20of%20Me
      var audioDbApiKey = "1"; // Just the free public one.
      var url = `https://www.theaudiodb.com/api/v1/json/${audioDbApiKey}/searchtrack.php?s=${encodeURIComponent(
        artist
      )}&t=${encodeURIComponent(trackName)}`;
      axios.get(url).then((response) => {
        console.log(response.data);
        _v.trackInfoDataAudioDb = response.data;
      });
    },
    saveToDatabase() {
      var _v = this;
      console.log(_v.trackRealPrimaryArtistName);
      var token = Storage.get("_t", "");
      axios
        .patch(
          `${this.apiRoot}/book/update-partial/${this.data.id}/`,
          {
            pk: _v.data.id,
            original_artist_name: this.trackRealPrimaryArtistName,
            original_track_title: _v.trackRealTitle,
            original_track_mbid: _v.trackRealTrackMbid,
            original_artist_mbid: _v.trackRealPrimaryArtistMbid,
            original_track_artist_array: map(_v.trackRealArtists, "text"),
            tags: map(_v.trackRealTags, "text"),
            original_metadata_added: true,
          },
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          alert(JSON.stringify(response.data, undefined, 2));
          _v.loadDjangoData();
        })
        .catch((response) => {
          alert(JSON.stringify(response, undefined, 2));
        });
    },
  },
};
</script>

<style lang="css" scoped>
label{
  font-size: 0.8em;
  }
</style>
